export var validateEmail = function (email) {
    var emailRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    return emailRegex.test(email);
};
export var validZipCodeCharacter = function (character) { return !!character.match(/^[a-z0-9-\s]+$/i); };
export var validatePositiveNumber = function (num) {
    var numberRegex = new RegExp(/^\d*$/);
    return numberRegex.test(num);
};
export var validatePhoneNumber = function (num) {
    var numberRegex = new RegExp(/^\+?[0-9-+]*$/);
    return numberRegex.test(num);
};
//# sourceMappingURL=validators.js.map